var map = {
	"./game_icon_assist.png": "ef56",
	"./game_icon_down.png": "4ad7",
	"./game_icon_goal.png": "82f2",
	"./game_icon_ownGoal.png": "0a55",
	"./game_icon_penalty.png": "6c5a",
	"./game_icon_red.png": "4e31",
	"./game_icon_score.png": "0240",
	"./game_icon_up.png": "3b37",
	"./game_icon_yellow.png": "d2e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6cfb";